export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export function waitForNextFrame() {
    return new Promise(resolve => requestAnimationFrame(resolve));
}

/**
 * Wartet auf eine bestimmte Anzahl von Browser-Frames (requestAnimationFrame) als Alternative zum klassischen setTimeout
 * 
 * @param {number} anzahl - Anzahl der Frames, auf die gewartet werden soll (Standard: 1)
 * @returns {Promise<void>}
 * 
 * @example
 * // Warten auf zwei Frames
 * await waitForFrames(2);
 */
export function waitForFrames(anzahl = 1) {
    return new Promise(resolve => {
        let count = 0;
        
        function nextFrame() {
            count++;
            if (count >= anzahl) {
                resolve();
            } else {
                requestAnimationFrame(nextFrame);
            }
        }
        
        requestAnimationFrame(nextFrame);
    });
}
